<div *ngIf="partners.length > 0" class="flex flex-col mt-10">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Parceiro
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'theme.edit']"
              >
                Temas
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let partner of partners">
              <td class="px-6 py-4 pl-4 font-medium text-md text-chathams-blue text-center whitespace-nowrap">
                <ng-container *ngIf="partner.active">
                  <span class="block w-3 h-3 rounded-full bg-status-success"></span>
                </ng-container>
                <ng-container *ngIf="!partner.active">
                  <span class="block w-3 h-3 rounded-full bg-red-500"></span>
                </ng-container>
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ partner.name }}
              </td>

              <td
                class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'theme.edit']"
              >
                <button
                  *isAllowed="[ERoleAdminString.Admin, 'theme.edit']"
                  [routerLink]="'temas-parceiro/' + partner.id"
                  [attr.aria-label]="'Editar temas do parceiro ' + partner.name"
                  title="Editar temas deste parceiro"
                  class="flex items-center justify-center gap-2 px-4 h-8 rounded-full bg-iceberg font-medium"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#000000"
                    width="18"
                    height="18"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                  Editar temas
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-no-results-found [condition]="partners.length === 0"></app-no-results-found>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
